import {
    AbstractPopupMenuProvider,
    PopupMenuProviderType,
} from './AbstractPopupMenuProvider';

class PopupCreateMenuProvider extends AbstractPopupMenuProvider {
    protected getPopupMenuType() {
        return PopupMenuProviderType.Create;
    }
}

export default PopupCreateMenuProvider;
